module.exports = __webpack_public_path__ + "images/home/fioleCM.7a1a1346.svg";